var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoucherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5445 6.26115L9.26465 7.54102L10.5445 8.82088L11.8244 7.54102L10.5445 6.26115Z",
    fill: "#FD6C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4698 8.17131L11.1899 9.45117L12.4698 10.731L13.7497 9.45117L12.4698 8.17131Z",
    fill: "#FD6C7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3.45L15 3L12 0L0 12L3 15L3.48 14.52C3.75981 14.3182 4.1024 14.2228 4.44622 14.2509C4.79005 14.279 5.11259 14.4288 5.35592 14.6733C5.59925 14.9179 5.74742 15.2412 5.77383 15.5851C5.80024 15.9291 5.70315 16.2712 5.5 16.55L5 17L8 20L20 8L17 5L16.52 5.48C16.2432 5.68609 15.902 5.7867 15.5577 5.76377C15.2133 5.74083 14.8885 5.59584 14.6415 5.35486C14.3945 5.11387 14.2415 4.7927 14.2101 4.44904C14.1786 4.10539 14.2708 3.76179 14.47 3.48L14.5 3.45ZM17 6.88L18.08 8L15.18 10.9L14.38 10.1L13.11 11.38L13.9 12.18L8 18.08L6.88 17C7.22389 16.4606 7.37342 15.8199 7.30387 15.184C7.23432 14.548 6.94985 13.9549 6.49749 13.5025C6.04513 13.0501 5.45196 12.7657 4.81602 12.6961C4.18008 12.6266 3.53944 12.7761 3 13.12L1.92 12L7.83 6.1L8.63 6.9L9.91 5.62L9.11 4.82L12 1.92L13.12 3C12.7761 3.53944 12.6266 4.18008 12.6961 4.81602C12.7657 5.45196 13.0501 6.04513 13.5025 6.49749C13.9549 6.94985 14.548 7.23432 15.184 7.30387C15.8199 7.37342 16.4606 7.22389 17 6.88Z",
    fill: "#FD6C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherIcon);
export default __webpack_public_path__ + "static/media/voucher-icon.8bf3494f2bf5bd0a4e7ebb500308ff7a.svg";
export { ForwardRef as ReactComponent };